import { TextField } from '@mui/material'
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import React, { useEffect } from 'react'

const DobCKYC = ({ field, form, ...props }) => {

    useEffect(() => {

        console.log('s', field)
    }, [])

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <MobileDatePicker
                disableFuture
                id={field.name}
                name={field.name}
                value={field.value}
                inputFormat="DD-MMMM-YYYY"

                onChange={(newValue) => {
                    form.setFieldValue(field.name, moment(newValue).format("YYYY-MM-DD"))
                }}
                renderInput={(params) => {
                    //console.log('param',params)
                    return (

                        <TextField
                            //touched={form.touched}
                            name={field.name}
                            id={field.name}
                            sx={{
                                /* "& label.Mui-focused": {
                                  display: "none"
                                }, */

                                "& legend": {
                                    display: "none"
                                },
                                '& .MuiOutlinedInput-root': {

                                    "&.Mui-error fieldset ": {
                                        borderColor: "rgba(0, 0, 0, 0.23) !important"  // default
                                    },



                                },


                            }}
                            //error={Boolean(currentError)}

                            fullWidth
                            {...params} />
                    )
                }}
            />
        </LocalizationProvider>
    )
}

export default DobCKYC